import { Icons } from 'assets';
import { TreatmentOnGoingActionButton } from 'components/atoms';
import React from 'react';
import { DialogCustom } from 'components/DialogCustom';

import { Box, Stack } from '@mui/material';
import { useTreatmentOnGoing } from 'context';
import { useDisclose } from 'hooks/utilHooks';

export const TreatmentOnGoingActionButtons: React.FC = () => {
  const {
    riskClassificationModal,
    petInformationsModal,
    tutorLocationModal,
    finishTreatmentOnGoing,
    loading,
    petFilesModal,
    treatmentOnGoing,
  } = useTreatmentOnGoing();
  const finishModal = useDisclose();
  
  const ITEMS = [
    {
      title: 'TRIAGEM',
      icon: Icons.AssignmentIcon,
      onClick: () => {
        riskClassificationModal.onOpen();
        petInformationsModal.onClose();
        tutorLocationModal.onClose();
        petFilesModal.onClose();
      },
      selected: riskClassificationModal.isOpen,
    },
    {
      title: 'DADOS DO PET',
      icon: Icons.PetPawIcon,
      onClick: () => {
        petInformationsModal.onOpen();
        riskClassificationModal.onClose();
        tutorLocationModal.onClose();
        petFilesModal.onClose();
      },
      selected: petInformationsModal.isOpen,
    },
    {
      title: 'LOCALIZAÇÃO',
      icon: Icons.MapIcon,
      onClick: () => {
        tutorLocationModal.onOpen();
        riskClassificationModal.onClose();
        petInformationsModal.onClose();
        petFilesModal.onClose();
      },
      selected: tutorLocationModal.isOpen,
    },
    treatmentOnGoing.documents?.length ? 
    {
      title: 'FOTOS E ARQUIVOS',
      icon: Icons.PdfFilWhite,
      onClick: async () => {
        petFilesModal.onOpen();
        petInformationsModal.onClose();
        tutorLocationModal.onClose();
        riskClassificationModal.onClose();
      },
      disableSelection: true,
      selected: false,
    } : {},
    {
      title: 'ENCERRAR ATENDIMENTO',
      icon: Icons.FinishCallIcon,
      onClick: finishModal.onOpen,
      disableSelection: true,
      selected: false,
    },

  ];

  return (
    <Box
      border="10px solid #F7E6D3"
      sx={{ backgroundColor: '#F7E6D3' }}
      borderRadius="10px"
      flex={1}
      height="100%"
    >
      <Stack flex={1} height="100%" borderRadius="10px" overflow="hidden">
        {ITEMS.map(({ icon, title, onClick, selected }: any, index) => (
          <TreatmentOnGoingActionButton
            key={title}
            selected={selected}
            onClick={onClick}
            icon={icon}
          >
            {title}
          </TreatmentOnGoingActionButton>
        ))}
      </Stack>

      <DialogCustom
        title="Encerramento de Chamada"
        text="Você deseja mesmo encerrar essa chamada?"
        isOpen={finishModal.isOpen}
        onClose={finishModal.onClose}
        loading={loading}
        onClick={finishTreatmentOnGoing}
      />
    </Box>
  );
};
